export default __webpack_public_path__ + "static/media/04.3ae69ad2.webp";